/* @flow */
import TextBadge from './TextBadge.jsx';

export type TextBadgeColor = 'lava' | 'shamrock' | 'wolf' | 'polar-bear' | 'eclipse' | 'sunrise';
export type TextBadgeTextColor = 'white' | 'thunder' | 'pitch' | 'lava' | 'flame';

export default TextBadge;
